<template>
  <div class="app_form">
    <van-dropdown-menu
      :class="isMobile ? 'topBar isMobile' : 'topBar notMobile'"
      get-container="body"
      :close-on-click-outside="false"
      active-color="#1989fa"
    >
      <van-dropdown-item title="筛选" ref="filter">
        <van-form>
          <van-field
            readonly
            clickable
            clearable
            name="picker"
            :value="param.params.startDate"
            label="开始时间"
            placeholder="点击选择"
            @click="showPicker = true"
          />
          <van-field
            readonly
            clickable
            clearable
            name="picker"
            :value="param.params.endDate"
            label="结束时间"
            placeholder="点击选择"
            @click="showEndPicker = true"
          />
          <van-field v-model="param.params.xm" label="姓名" placeholder="请输入姓名" />
          <van-field
            v-model="param.params.zyfzr2"
            label="工号"
            placeholder="请输入工号"
          />
          <van-field
            readonly
            clickable
            clearable
            name="picker"
            :value="param.params.zyzt"
            label="作业完成状态"
            placeholder="点击选择状态"
            @click="onClick('status')"
          />
          <!-- <van-field
            readonly
            clickable
            clearable
            name="picker"
            :value="param.params.taskStatus"
            label="流程状态"
            placeholder="点击选择状态"
            @click="onClick('taskStatus')"
          /> -->
        </van-form>
        <div style="margin: 10px; display: flex; justify-content: center">
          <van-button
            size="small"
            round
            native-type="submit"
            style="padding: 0 20px; margin-right: 20px"
            @click="clearData"
            >重置</van-button
          >
          <van-button
            size="small"
            round
            type="info"
            native-type="submit"
            style="padding: 0 20px"
            @click="onSubmit"
            >筛选</van-button
          >
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>
    <!-- 流程弹出框 -->
    <van-popup v-model="showProcPicker" position="bottom" :style="{ height: '40%' }">
      <van-picker
        :title="title"
        show-toolbar
        visible-item-count="5"
        :columns="timeOptions"
        @confirm="onConfirm"
        @cancel="showProcPicker = false"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom" get-container="#app">
      <van-datetime-picker
        v-model="startDate"
        type="date"
        title="选择日期"
        @confirm="onDeal"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showEndPicker" position="bottom" get-container="#app">
    <van-datetime-picker
        v-model="endDate"
        type="date"
        title="选择日期"
        @confirm="onEndDeal"
        @cancel="showEndPicker = false"
      />
       </van-popup>
    <van-list
      :style="isMobile ? 'padding-top: 45px;' : 'padding-top: 90px;'"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getData"
    >
      <el-card class="card_form" style="margin: 10px" v-for="item in tableData">
        <div class="app_form_title" @click="onClickFlow(item)">
          <span class="formName">{{ item.name | ellipsis }}</span>
          <div class="step">
            <van-steps :active="0" direction="vertical">
              <van-step v-for="sItem in tableColumn">
                {{ sItem.label + ':' }}
                <span class="span">{{ item[sItem.prop] }}</span>
              </van-step>
            </van-steps>
          </div>
        </div>
      </el-card>
    </van-list>
  </div>
</template>
<script>
import * as hoistApplyApi from '../../../api/hoistApply'
import * as tmplApi from '@/api/templateApi'
import { formatDate } from '../../../util/formatUtil'
import {
  Step,
  Steps,
  Empty,
  List,
  Icon,
  Cell,
  CellGroup,
  NavBar,
  DropdownMenu,
  DropdownItem,
  Button,
  Search,
  Form,
  Field,
  Popup,
  Picker,
  DatetimePicker
} from 'vant'
export default {
  data() {
    return {
      tableColumn: [
        { label: '作业负责人', prop: 'xm' },
        { label: '工号', prop: 'gh' },
        { label: '名称', prop: 'title' },
        { label: '发起时间', prop: 'CreateTime' },
        { label: '需求时间', prop: 'xqsj' },
        { label: '吊装区域', prop: 'dzqy' },
        { label: '当前状态', prop: 'zyzt' },
        { label: '项目号', prop: 'xmbh' },
        { label: '吊装类型', prop: 'dclx' },
        { label: '数量', prop: 'sl' }
      ],
      tableData: [],
      timeOptions: [],
      param: {
        page: 0,
        size: 10,
        params: {
          startDate: this.getDate(new Date()),
          endDate:this.getEndData(new Date())
        }
      },
      isMobile: false,
      loading: false,
      finished: false,
      showProcPicker: false,
      showPicker: false,
      showEndPicker: false,
      startDate: new Date(),
      endDate:new Date(),
      title: ''
    }
  },
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Empty.name]: Empty,
    [List.name]: List,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Search.name]: Search,
    [Field.name]: Field,
    [Form.name]: Form,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker
  },
  mounted() {
    //标记从哪个页面跳过来的，mb 表示移动端
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // 检测是否手机端
      this.isMobile = true
    }
  },
  filters: {
    //文字数超出时，超出部分使用...
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 12) {
        return value.slice(0, 12) + '...'
      }
      return value
    }
  },
  methods: {
    getData() {
      // 获取吊装申请列表
      this.param.page += 1
      hoistApplyApi
        .detailPageData(this.param)
        .then((res) => {
          this.loading = false
          if (res.success) {
            if (this.param.page === 1) this.tableData = []
            if (res.data && res.data.data.length) {
              res.data.data.forEach((item) => {
                if (!item.xm) {
                  item.xm = '未分配'
                }
                this.tableData.push(item)
              })
            } else {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.finished = true
          this.loading = false
        })
    },
    clearData() {
      //清空表单数据
      this.param.params.startDate = ''
      this.param.params.endDate = ''
      this.param.params.zyzt = ''
      this.param.params.xm = ''
      this.param.params.zyfzr2 = ''
      this.param.params.taskStatus = ''
      this.param.page = 0
      this.finished = false
      this.$refs.filter.toggle()
    },
    onClick(type) {
      if (type === 'status') {
        this.title = '选择作业完成状态'
        this.timeOptions = ['已完成', '作业中', '未开始', '未完成']
      } else if (type === 'taskStatus') {
        this.title = '选择流程状态'
        this.timeOptions = ['审批中', '已同意', '已拒绝', '已撤销']
      }
      this.showProcPicker = true
    },
    onSubmit() {
      this.param.page = 0
      this.$refs.filter.toggle()
      if (this.finished) {
        this.finished = false
      } else {
        this.getData()
      }
    },
    onConfirm(data) {
      if (this.title === '选择作业完成状态') {
        this.param.params.zyzt = data
      } else if (this.title === '选择流程状态') {
        this.param.params.taskStatus = data
      }
      this.showProcPicker = false
    },
    onDeal() {
      this.showPicker = false
      this.param.params.startDate = this.getDate(this.startDate)
     
    },
    onEndDeal() {
      this.showEndPicker = false
      this.param.params.endDate = this.getEndData(this.endDate)
    },
    getDate(date) {
      return formatDate(date, 'yyyy-MM-dd')
    },
    getEndData(date) {
      return formatDate(date, 'yyyy-MM-dd')
    },
    onClickRoute(index) {
      // 路由跳转
      let routes = new Map([
        ['/workplace', '/mobile'],
        ['/myWork', '/mobileMydb'],
        ['/createFlow', '/mobileFlow']
      ])
      if (index.startsWith('/flow')) {
        let url = index.replace('/flow', '/mobileForm')
        this.$router.push({ path: url })
      } else {
        this.$router.push({ path: routes.get(index) })
      }
    },
    onClickLeft() {
      this.$router.push({
        path: '/mobile'
      })
    },
    onClickFlow(item) {
      let params = {
        funCode: '10001722',
        businessId: item.ID,
        type: 1
      }
      tmplApi.shareInfo(params).then((res) => {
        if (res.success) {
          this.$router.push({
            path: '/ddFlow?f=mb&funCode=10001722' + '&id=' + item.ID
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.flow-state {
  background: #ebf8f7;
  color: #0db3a6;
  width: 70px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 100px;
  border: 1px solid #0db3a6;
  font-size: 12px;
  float: right;
}
span.formName {
  font-weight: bold;
  font-size: 14px;
}
.span {
  font-size: 15px;
  color: black;
  margin-left: auto;
}
.topBar {
  width: 100%;
  position: fixed;
  z-index: 10;
}
.isMobile {
  top: 0;
}
.notMobile {
  top: 46px;
}
::v-deep .van-step__title {
  transition: color 0.3s;
  display: flex;
}
::v-deep .van-step--vertical:not(:last-child)::after {
  border-bottom-width: 0px;
}
::v-deep .van-steps {
  overflow: inherit;
  background-color: #fff;
}
.card-back {
  height: 20px;
  background-color: #f6f6f6;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
::v-deep .van-nav-bar__text {
  color: #000000;
}
::v-deep .van-nav-bar .van-icon {
  color: #000000;
}
::v-deep .van-dropdown-menu__bar {
  box-shadow: 0 12px 12px -12px rgb(100 101 102 / 12%);
}
</style>
